import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "input", "submit", "selectAll", "select", "customReason", "defectDescription", "defectDescriptionHint"]
  static values  = { lookupUrl: String, defectDescriptionMinLength: Number }

  connect() {
    this.checkboxTargets.forEach((checkbox) => {
      this.toggleRow({ target: checkbox })
    })
    this.validate()
  }

  toggleRow(event) {
    const row = event.target.closest("tr")
    const input = row.querySelector("input[type='number']")
    input.disabled = !event.target.checked
    if (!event.target.checked) input.value = 0

    if (event.target.checked) {
      row.classList.add("selected")
    } else {
      row.classList.remove("selected")
    }

    this.validate()
  }

  rowClicked(event) {
    if (event.target.matches('input, select, button')) return

    const row = event.currentTarget
    const checkbox = row.querySelector('input[type="checkbox"]')
    if (checkbox) {
      checkbox.checked = !checkbox.checked
      this.toggleRow({ target: checkbox })
    }
  }

  handleReasonChange(event) {
    const select = event.target
    const rowIdx = select.dataset.rowIdx
    const customReasonField = this.customReasonTargets.find(field => field.dataset.rowIdx === rowIdx)
    const defectDescriptionField = this.defectDescriptionTargets.find(field => field.dataset.rowIdx === rowIdx)
    const defectDescriptionHint = this.defectDescriptionHintTargets.find(field => field.dataset.rowIdx === rowIdx)

    if (customReasonField) {
      if (select.value === 'other') {
        customReasonField.style.display = 'block'
        customReasonField.required = true
      } else {
        customReasonField.style.display = 'none'
        customReasonField.required = false
        customReasonField.value = ''
      }
    }

    if (defectDescriptionField) {
      if (select.value === 'defective') {
        defectDescriptionField.style.display = 'block'
        defectDescriptionField.required = true
        defectDescriptionHint?.style.setProperty('display', 'block')
      } else if (select.value === 'damaged') {
        defectDescriptionField.style.display = 'block'
        defectDescriptionField.required = false
        defectDescriptionHint?.style.setProperty('display', 'none')
      } else {
        defectDescriptionField.style.display = 'none'
        defectDescriptionField.required = false
        defectDescriptionField.value = ''
        defectDescriptionHint?.style.setProperty('display', 'none')
      }
    }

    this.validate()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(cb => {
      cb.checked = checked
      this.toggleRow({ target: cb })
    })
  }

  // Called when barcode-scanner controller dispatches barcode-scanner:scanned
  barcodeScanned(event) {
    this.lookup(event.detail.code)
  }

  async lookup(barcode) {
    if (!barcode || !this.lookupUrlValue) return

    const url = this.lookupUrlValue + '?barcode=' + encodeURIComponent(barcode)
    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } })
      const data     = await response.json()

      if (data.found) {
        this.highlightRow(data.product_id)
      } else {
        alert('❌ ' + data.message)
      }
    } catch (err) {
      alert('❌ Błąd: ' + err.message)
      console.error(err)
    }
  }

  highlightRow(productId) {
    const hiddenInput = document.querySelector(`input[name*="[product_id]"][value="${productId}"]`)
    if (!hiddenInput) return

    const row      = hiddenInput.closest('tr')
    const checkbox = row.querySelector('input[type="checkbox"]')
    if (checkbox && !checkbox.checked) {
      checkbox.checked = true
      checkbox.dispatchEvent(new Event('change', { bubbles: true }))
    }
    row.scrollIntoView({ behavior: 'smooth', block: 'center' })
    row.classList.add('table-success')
    setTimeout(() => row.classList.remove('table-success'), 2000)
  }

  validate() {
    let anySelected = false
    let allPositive = true
    let allRequired = true
    const minDefectDescriptionLength = this.hasDefectDescriptionMinLengthValue ? this.defectDescriptionMinLengthValue : 10

    this.checkboxTargets.forEach((cb, idx) => {
      if (cb.checked) {
        anySelected = true
        const qty = parseInt(this.inputTargets[idx].value, 10) || 0
        if (qty <= 0) allPositive = false

        const row = cb.closest('tr')
        const reasonSelect = row.querySelector('[data-return-form-target="select"]')
        if (reasonSelect && reasonSelect.value === 'defective') {
          const defectDesc = row.querySelector('[data-return-form-target="defectDescription"]')
          if (!defectDesc || defectDesc.value.trim().length < minDefectDescriptionLength) allRequired = false
        }
        if (reasonSelect && reasonSelect.value === 'other') {
          const customReason = row.querySelector('[data-return-form-target="customReason"]')
          if (!customReason || !customReason.value.trim()) allRequired = false
        }
      }
    })

    const formOK = anySelected && allPositive && allRequired
    if (this.hasSubmitTarget) this.submitTarget.disabled = !formOK
  }

  inputChanged() {
    this.validate()
  }
}
